<template>
    <div class="container">
        <b-modal
            :model-value="showDialogEdit"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-3">
                    <div class="password-policy-title">{{ labels.formInfoTitle }}</div>
                    <div class="password-policy-item">{{ labels.formInfoSubtitle }}</div>
                </div>

                <b-col md="4" lg="12" class="p-0 mx-auto">
                    <b-form-group @submit.prevent="editaInfoUser">
                        <label>{{labels.name}} </label>
                        <b-form-input v-model="formEdit.nameUser" type="text" class="reset-input"></b-form-input><br>
                        <label>{{labels.identificationCard}} </label>
                        <b-form-input v-model="formEdit.cedula" type="text" class="reset-input"></b-form-input><br>
                        <label>{{labels.email}} </label>
                        <b-form-input v-model="formEdit.correo" type="email" class="reset-input"></b-form-input><br>
                        <label>{{labels.phone}} </label>
                        <b-form-input v-model="formEdit.phone" type="text" class="reset-input"></b-form-input><br>
                        <label>{{labels.role}} </label>
                        <b-form-select v-model="formEdit.id_rol" class="reset-input">
                            <option v-for="rol in listaRol" :key="rol?.id" :value="rol?.id">{{ rol?.nombre }}</option>
                        </b-form-select><br>
                        <label>{{labels.passw}} </label>
                        <b-form-input v-model="formEdit.password" type="password" class="reset-input"></b-form-input><br>
                    </b-form-group>
                    <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                        <b-button class="mr-2 reset-btn-secondary" @click="cierraModal()">{{ labels.close }}</b-button>
                        <b-button class="reset-btn-primary" @click="editaInfoUser()">{{ labels.save }}</b-button>
                    </div>
                </b-col>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Roles from '../../services/Roles';
import User from '../../services/User';

export default {
    name:"EditarUser",
    props:['showDialogEdit','formEdit'],
    data: () => ({
        listaRol : []
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : "Editar usuario",
                    save : "Guardar",
                    close : "Cerrar",
                    name : "Nombre",
                    identificationCard : "Cedula",
                    email : "Correo",
                    phone : "Teléfono",
                    role : "Rol",
                    passw : "Password",
                    formInfoTitle: "Datos del usuario",
                    formInfoSubtitle: "Actualiza la información del usuario y guarda los cambios."
                }
            }else{
                return {
                    title : "Edit user",
                    save : "Save",
                    close : "Close",
                    name : "Name",
                    identificationCard : "Identification card",
                    email : "Email",
                    phone : "Phone",
                    role : "Role",
                    passw : "Password",
                    formInfoTitle: "User information",
                    formInfoSubtitle: "Update user information and save changes."
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false)
        },
        editaInfoUser(){
            User.updateUser(this.formEdit)
            .then(() => {
                this.$toast.success("Usuario editado correctamente")
                this.cierraModal()
                this.$emit('actualizado')
            })
            .catch(() => {
                this.$toast.error("No se pudo editar el usuario")
            })
        }
    },
    mounted(){
        Roles.getAllRoles()
        .then((rta) => {
            this.listaRol = rta.data.roles
        })
        .catch((error) => {
            console.log(error)
        })
    }
}
</script>
